import React from 'react';
import { HollowDotsSpinner } from 'react-epic-spinners';

import './LightMapLoader.css';
// import logo from '../../assets/images/logo.png';

const Loading = () => {
    return (
        <div>
            <div className='loading__backdrop'>
                <h2>Loading Data (60MB)</h2>
                <HollowDotsSpinner color='#ff9970'></HollowDotsSpinner>
            </div>

            {/* <img
				style={{ animation: `spin 3s linear infinite` }}
				src={logo}
				alt="img"
			/> */}
        </div>
    );
};

export default Loading;
